import jwt from 'jsonwebtoken';

export function decodeUserFromJwt(token) {
  return {
    ...jwt.decode(token).object.content,
    jwt: token,
    exp: jwt.decode(token).exp
  };
}
